import React from 'react';
import { object, string } from 'prop-types';
import pathfinder from '@fiverr-private/pathfinder';
import { sendBigQueryEvent } from '../../utils/bigQuery';
import withTranslation from '../../lib/withTranslation';
import { BIGQUERY_EVENT } from './constants';

const LogoutLink = ({ i18n, textKey = 'header.logout' }) => {
    const path = pathfinder('logout');

    const handleClick = () => {
        sendBigQueryEvent(BIGQUERY_EVENT);
    };

    return (
        <a href={path} className="js-log-out nav-link" onClick={handleClick}>
            {i18n.t(textKey)}
        </a>
    );
};

LogoutLink.propTypes = {
    i18n: object,
    textKey: string,
};

export default withTranslation(LogoutLink);
